/**
 Adds hover animations to a group of cards.
 - When a card is hovered, it gets 'active-card'
 and itself + all previous cards get 'is-translated'.
 - On mouse leave, everything resets.
 */
const AnimatedCard: () => void = (): void => {
  const animatedCards: HTMLElement[] = Array.from(
    document.querySelectorAll<HTMLElement>('.is-style-colorful-cards .a-icon-text')
  );
  if (animatedCards.length === 0) return;
  animatedCards.forEach((card, currentIndex) => {
    card.addEventListener('mouseenter', () => {
      // Ensure a clean state when moving quickly between cards
      animatedCards.forEach((c) => {
        c.classList.remove('active-card', 'is-translated');
      });
      // Always mark hovered card as active
      card.classList.add('active-card');
      if (currentIndex === 0) {
        // Unique case: first card also gets is-translated
        card.classList.add('is-translated');
      } else {
        // Mark ONLY previous cards as translated
        for (let i = 0; i < currentIndex; i++) {
          animatedCards[i].classList.add('is-translated');
        }
      }
    });
    card.addEventListener('mouseleave', () => {
      // Reset everything on leave
      animatedCards.forEach((c) => {
        c.classList.remove('active-card', 'is-translated');
      });
    });
  });
};
export default AnimatedCard;






